/**
 * تحديد نوع الجهاز بدقة
 * @returns {'android' | 'ios' | 'web'}
 */
export const getDeviceType = () => {
    const ua = navigator.userAgent.toLowerCase();

    // فحص Android
    if (/android/i.test(ua)) {
        return 'android';
    }

    // فحص iOS
    if (/iphone|ipad|ipod/i.test(ua)) {
        return 'ios';
    }

    // التحقق من standalone mode (PWA)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone ||
        document.referrer.includes('android-app://');

    if (isStandalone) {
        // في حالة PWA، نحدد بناءً على النظام
        if (/android/i.test(ua)) return 'android';
        if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
    }

    // افتراضي: web
    return 'web';
};

/**
 * الحصول على معلومات الجهاز
 */
export const getDeviceInfo = () => {
    const ua = navigator.userAgent;
    const deviceType = getDeviceType();

    return {
        device_type: deviceType,
        user_agent: ua,
        platform: navigator.platform,
        is_pwa: window.matchMedia('(display-mode: standalone)').matches,
        screen_width: window.screen.width,
        screen_height: window.screen.height,
    };
};
